import { ModuleWithProviders, NgModule } from '@angular/core';
import { NGXS_PLUGINS } from '@ngxs/store';
// Plugin
import { ClearStatePlugin, CLEAR_STATE_PLUGIN_OPTIONS } from './clear-state.plugin';

@NgModule()
export class ClearStatePluginModule {
	
	/**
	 * forRoot config
	 * 
	 * @param config 
	 * @returns 
	 */
	static forRoot(config?: any): ModuleWithProviders<any> {
		return {
			ngModule: ClearStatePluginModule,
			providers: [
				{
					provide: NGXS_PLUGINS,
					useClass: ClearStatePlugin,
					multi: true
				},
				{
					provide: CLEAR_STATE_PLUGIN_OPTIONS,
					useValue: config
				}
			]
		};
	}
}
